import { render, staticRenderFns } from "./FlotasCompartidas.vue?vue&type=template&id=e1e2fa4c&"
import script from "./FlotasCompartidas.vue?vue&type=script&lang=ts&"
export * from "./FlotasCompartidas.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('e1e2fa4c', component.options)
    } else {
      api.reload('e1e2fa4c', component.options)
    }
    module.hot.accept("./FlotasCompartidas.vue?vue&type=template&id=e1e2fa4c&", function () {
      api.rerender('e1e2fa4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plataforma/FlotasCompartidas.vue"
export default component.exports